class Constants {
    Max_Location_Capacity = 25;

    Pickup = "pickup";

    Drop = "drop";

    Portals = Object.freeze({
        LDI_CORPORATE: 1,
        CINDY_LOU_LLC: 1036
    });

    Customers = Object.freeze({
      MONSTER_ENERGY_COMPANY: 5990, // Monster Energy Company 5990 HAN_109
      WRAP_TITE_957: 34654,
      DUNN_EDWARDS_CORPORATION: 34492,
      DUNN_EDWARDS_CORPORATION_SOCAL: 36114,
      TRUCK_PRO_LLC: 26423,
      CCC_PARTS: 26798,
      DANA_CORP: 27124,
      REFLEXXION_AUTOMOTIVE_PRODUCTS_LLC: 26424
    });

    Carriers = Object.freeze({
      COFC_LOGISTICS: 206954,
      MATSON_LOGISTICS_INC: 206953,
      CPKC: 217628,
      CN: 139626
    });

    packingGroupOptions = Object.freeze([
        { label: 'I', value: 'I' },
        { label: 'II', value: 'II' },
        { label: 'III', value: 'III' },
        { label: 'N/A', value: 'NONE' }
    ]);

    hazmatLabelOptions = Object.freeze([
      {name:'UN'},
      {name:'NA'}
    ]);


    emptyIMHazmatInfo = Object.freeze({
      LoadFreightHazmatInfoID: null,
      IDNumberType: 'UN',
      IDNumber: null,
      ShippingName: null,
      HazardClass: null,
      PackingGroup: null,
      PackageType: null,
      Pieces: null,
      Weight: null,
      ContactName: null,
      ContactPhone: null
    });

    MasterStatusArray=[
        { name: "Posting", id: "9" },
        { name: "Available", id: "0" },
        { name: "Covered", id: "1" },
        { name: "Dispatched", id: "8" },
        { name: "In-Transit", id: "2" },
        { name: "Delivered", id: "3" },
        { name: "Cancelled", id: "5" },
        { name: "Claims", id: "6" },
        { name: "On Hold", id: "7" }      
    ];

    DrayType = Object.freeze({
      ORIGIN_PORT_DRAY: 1,
      ORIGIN_DRAY: 2,
      INTERMEDIATE_DRAY: 3,
      DESTINATION_DRAY: 4,
      DESTINATION_PORT_DRAY: 5,
      RAIL_CARRIER_D2D: 6,
    });

    originDrayTypeIDs = [this.DrayType.ORIGIN_PORT_DRAY, this.DrayType.ORIGIN_DRAY];

    destDrayTypeIDs = [this.DrayType.DESTINATION_PORT_DRAY, this.DrayType.DESTINATION_DRAY];

    CustomsBrokerType = Object.freeze({
      IMPORT: 1,
      EXPORT: 2
    });

    loadType = Object.freeze({
        LTL: 0,
        FTL: 1,
        IML: 2
    });

    
    AIAgent = Object.freeze({
        LaneSurf: 1
    });

    lineItemsAllowedOnce = Object.freeze([
        1,  // miles
        5,  // fuel miles
        10, // rail line haul
        14 //  rail fuel surcharge
    ]);
}

const constants = new Constants();
export const Customers = constants.Customers;
export default constants;